import React from 'react';
import {ReactComponent as ArrayIcon} from '../../../../../../../assets/main/groups/main-table/array.svg';
import {Link} from "react-router-dom";
import {useAppSelector} from "common/hook";
import {getCabinetData} from "entities/Cabiner/model/selectors/getCabinetData/getCabinetData";
import {ALL_GROUPS, GROUPS} from "entities/constants/constants";
import {NothingYetMessage} from "../../../../nothing-yet-message/NothingYetMessage";

export const GroupCart = () => {
    const cabinetData = useAppSelector(getCabinetData);


    return (
        <div className="info-card">
            <div className="info-card-hdr">
                <div className="title-box">
                    <p className="info-card-title h4">{GROUPS}</p>
                </div>
                {cabinetData?.groups &&
                    <span className="sub-data">{cabinetData?.groups.count}</span>
                }
            </div>
            {cabinetData?.groups && cabinetData?.groups.items.length > 0 ? (
                <div className="info-card-content">
                    {cabinetData?.groups.items.map((group, index) => (
                        <div className="row" key={index}>
                            <p>
                                <Link to={`/groups/${group.id}`}>{group.title}</Link>
                            </p>
                            <div className="group-item-data">
                                <span className="complited-count">{group.level}</span>
                                {group.company && <p className="sub-text">{group.company}</p>}
                                <div className="students-number">
                                    {group.avatars.map((ava, index) => {
                                        return (
                                            <div className="avatar" key={index}>
                                                <img src={ava.key} alt=""/>
                                            </div>
                                        );
                                    })}
                                    <span className="num">{group.studentsCount}</span>
                                </div>
                            </div>
                        </div>
                    ))}
                    {cabinetData && cabinetData.groups && cabinetData.groups.items && cabinetData.groups.items.length > 0 && (
                        <div className='block-arrow-link'>
                            <Link to='/groups' className='arrow-link'>{ALL_GROUPS}<ArrayIcon className="arrow"/></Link>
                        </div>
                    )}
                </div>
            ) : (
                <div className="info-card-content">
                    <NothingYetMessage/>
                </div>
            )}

        </div>
    );
}
